import clsx from 'clsx';
import { CheckIcon } from '@heroicons/react/24/outline';
import { DATA_UPDATE_GROUP_ICONS } from '../../dataUpdate.definitions';
import { summarizeGroup } from '../../dpRequests.formatters';
import type { DataUpdateGroupPickerProps } from './dataUpdateGroupPicker.types';

export function DataUpdateGroupPicker({ groups, values, selected, onToggle, disabled = false }: DataUpdateGroupPickerProps) {
    return (
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            {groups.map(group => {
                const Icon = DATA_UPDATE_GROUP_ICONS[group.id];
                const isSelected = selected.includes(group.id);
                return (
                    <button
                        key={group.id}
                        type="button"
                        aria-pressed={isSelected}
                        disabled={disabled}
                        onClick={() => onToggle(group.id)}
                        className={clsx(
                            'group relative flex items-start gap-3 rounded-2xl border p-4 text-left transition',
                            'focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary-500 disabled:cursor-not-allowed disabled:opacity-60',
                            isSelected
                                ? 'border-primary-500 bg-primary-50 shadow-sm'
                                : 'border-raro-gray-200 bg-white hover:border-primary-200 hover:shadow-sm'
                        )}
                    >
                        <span
                            className={clsx(
                                'flex h-10 w-10 shrink-0 items-center justify-center rounded-xl',
                                isSelected ? 'bg-primary-600 text-white' : 'bg-primary-50 text-primary-600'
                            )}
                        >
                            <Icon className="h-5 w-5" aria-hidden="true" />
                        </span>

                        <span className="min-w-0 flex-1">
                            <span className="block font-montserrat text-sm font-semibold text-raro-gray-900">{group.label}</span>
                            <span className="mt-0.5 block truncate text-xs text-raro-gray-500">{summarizeGroup(group.id, values)}</span>
                            {group.requiresAttachment && (
                                <span className="mt-2 inline-block rounded-full bg-amber-50 px-2 py-0.5 text-[11px] font-medium text-amber-700">
                                    Pede comprovante
                                </span>
                            )}
                        </span>

                        <span
                            className={clsx(
                                'absolute right-3 top-3 flex h-5 w-5 items-center justify-center rounded-full border transition',
                                isSelected ? 'border-primary-600 bg-primary-600 text-white' : 'border-raro-gray-300 bg-white text-transparent'
                            )}
                            aria-hidden="true"
                        >
                            <CheckIcon className="h-3.5 w-3.5" />
                        </span>
                    </button>
                );
            })}
        </div>
    );
}
